:host {
    display: flex;
    flex-direction: column;
    padding: 15px 10px;
    border-inline-end: 1px solid #9ea9b0;
    border-block-end: 1px solid #9ea9b0;
    grid-column: auto / span var(--ux-cell-span);
    gap: 0 10px;
    position: relative;
}

:host([borderless]) {
    border: 0;
}

::slotted(ux-copy) {
    margin-block-start: 0;
    margin-block-end: 0;
}

:host([sortable]) {
    cursor: pointer;
}

:host([head]) {
    flex-direction: row;
    text-transform: uppercase;

    #labelContainer {
        @container style(--trumpf-ux-theme: web) {
            align-items: end;
        }

        align-items: normal;
    }

    overflow: hidden;
}

:host([sorted][head]) {
    #labelContainer {
        border-color: black;
    }
}

#labelContainer {
    display: flex;
    align-items: center;
    gap: 0 10px;
    padding-block-start: 5px;
    padding-block-end: 5px;
    border-block-end: 1px solid transparent;
}

:host(:not([head]):hover) {
    background-color: var(--ux-table-col-hover-color, #f0f0f0);
}